import React, { useState, useEffect } from "react";
import Select from "react-select";
import { toast } from "react-toastify";
import { Spinner } from "../../components/Spinner"; // Se mantiene la importación por si se usa en otro lado, pero ya no se renderiza aquí para detalles
import ReactPaginate from "react-paginate";
import TotalProtect from "./../../assets/img/logos/logoTPT.png";

import useCeo from "../../hooks/useCEO";
import { useUnidades } from "../../hooks/test/useUnidades";
import { useNegocios } from "../../hooks/useNegocios";
import { useCedisProtocols } from "../../hooks/useCedisProtocols";

import { ProtocoloCard } from "../../components/customFunctionalComponents/components/ProtocoloCard";
import { ModalProtocolos } from "../../components/customComponents/Modals/ModalProtocolos";
import { SideCard } from "../../components/customFunctionalComponents/components/SideCardProtocols";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";

export const AdministracionProtocolos = () => {
    useCeo({
        title: "Administración de Protocolos",
        description: "Página de gestión de protocolos de seguridad",
    });

    const {
        postProtocolos,
        putProtocolos,
        getProtocolos,
        postEscalamiento,
        deleteEscalamiento,
        deleteGruposChat,
        putGruposChat,
        postGruposChat,
        getGruposChat,
    } = useUnidades();

    const { negocios, isLoadingNegocios, errorNegocios, reloadNegocios } = useNegocios();
    const [selectedNegocioId, setSelectedNegocioId] = useState(null);

    useEffect(() => {
        if(selectedNegocioId !== null) return;
        if(negocios.length > 0) {
            setSelectedNegocioId(negocios[0].negocio_id);
            // console.log ("[AdministracionProtocolos] Negocio seleccionado por defecto:", negocios[0].negocio_id);
        }
    }, [negocios, selectedNegocioId]);

    const {
        cedisForSelectedNegocio,
        isLoadingCedisProtocols,
        errorCedisProtocols,
        reloadCedisProtocols
    } = useCedisProtocols(selectedNegocioId, negocios);

    const [selectCedisId, setSelectCedisId] = useState(null);
    const [selectedProtocol, setSelectedProtocol] = useState(null);
    const [showModal, setShowModal] = useState(false);

    // Estados para el SideCard
    const [showSideCard, setShowSideCard] = useState(false);
    const [sideCardProtocolData, setSideCardProtocolData] = useState(null);

    const [isLoadingProtocolDetails, setIsLoadingProtocolDetails] = useState(false);
    const [errorProtocolDetails, setErrorProtocolDetails] = useState(null);

    const [shouldReloadOnModalClose, setShouldReloadOnModalClose] = useState(false);

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 12;
    const [pageCount, setPageCount] = useState(0);

    useEffect(() => {
        const filtered = selectCedisId
            ? cedisForSelectedNegocio.filter(cedis => cedis.cedis_id === selectCedisId)
            : cedisForSelectedNegocio;
        setPageCount(Math.ceil(filtered.length / itemsPerPage));
        setCurrentPage(0);
    }, [cedisForSelectedNegocio, selectCedisId, itemsPerPage]);

    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    const handleShowModal = async (cedisItem) => {
        // console.log("[AdministracionProtocolos] --- Iniciando handleShowModal para CEDIS:", cedisItem.nombre_cedis, "---");
        // console.log("[AdministracionProtocolos] cedisItem recibido:", cedisItem);
        const hasProtocoloSeguridad = !!cedisItem.protocolos_seguridad;
        // console.log("[AdministracionProtocolos] hasProtocoloSeguridad:", hasProtocoloSeguridad);

        let finalProtocolDataForModal = {
            id: hasProtocoloSeguridad ? cedisItem.protocolos_seguridad.protocolo_id : "TEMP_" + cedisItem.cedis_id + "_" + selectedNegocioId,
            titulo_protocolo: hasProtocoloSeguridad ? cedisItem.protocolos_seguridad.titulo_protocolo : "Protocolo para " + cedisItem.nombre_cedis,
            evento_riesgo: '',
            cedis_id: cedisItem.cedis_id,
            cedisNombre: cedisItem.nombre_cedis,
            escalamientos: [],
            grupos_mensajeria: [], // Inicializamos vacío
            negocio_id: selectedNegocioId
        };

        setIsLoadingProtocolDetails(true);
        setErrorProtocolDetails(null);

        try {
            if (hasProtocoloSeguridad && cedisItem.protocolos_seguridad.protocolo_id) {
                // console.log("[AdministracionProtocolos] CEDIS tiene protocolo existente. Obteniendo detalles completos...");
                // console.log("[AdministracionProtocolos] Protocolo ID a buscar:", cedisItem.protocolos_seguridad.protocolo_id);

                const protocoloResp = await getProtocolos(cedisItem.cedis_id);
                // console.log("[AdministracionProtocolos] Respuesta de getProtocolos (detalles completos):", protocoloResp);


                if (protocoloResp.ok && protocoloResp.protocolo) {
                    finalProtocolDataForModal = {
                        ...finalProtocolDataForModal,
                        id: protocoloResp.protocolo.protocolo_id,
                        titulo_protocolo: protocoloResp.protocolo.titulo_protocolo || finalProtocolDataForModal.titulo_protocolo,
                        evento_riesgo: protocoloResp.protocolo.evento_riesgo || '',
                        escalamientos: protocoloResp.protocolo.protocolo_escalamientos || [],
                    };
                    // console.log("[AdministracionProtocolos] Detalles de escalamientos recibidos de getProtocolos:", protocoloResp.protocolo.protocolo_escalamientos);
                } else {
                    toast.error(protocoloResp.msg || "Error al cargar los detalles del protocolo.");
                    setErrorProtocolDetails(new Error(protocoloResp.msg || "Error desconocido al cargar detalles del protocolo."));
                    setIsLoadingProtocolDetails(false);
                    return;
                }
            } 
            // else {
                // console.log("[AdministracionProtocolos] CEDIS no tiene protocolo existente. Preparando para crear nuevo.");
            // }

            const gruposResp = await getGruposChat(cedisItem.cedis_id);
            // console.log("[AdministracionProtocolos] Respuesta de getGruposChat:", gruposResp);

            if (gruposResp.ok && gruposResp.grupos) {
                finalProtocolDataForModal.grupos_mensajeria = gruposResp.grupos;
                // console.log("[AdministracionProtocolos] Grupos de mensajería recibidos:", gruposResp.grupos);
            } else {
                // toast.warn(gruposResp.msg || "No se pudieron cargar los grupos de mensajería para este CEDIS.");
            }

        } catch (error) {
            // console.error("Error al obtener detalles del protocolo o grupos de chat:", error);
            toast.error("Ocurrió un error al cargar los detalles del protocolo o grupos de chat.");
            setErrorProtocolDetails(error);
        } finally {
            setIsLoadingProtocolDetails(false);
            // console.log("[AdministracionProtocolos] Final protocolDataForModal (pasado al modal):", finalProtocolDataForModal);
            setSelectedProtocol(finalProtocolDataForModal);
            setShowModal(true);
        }
    };

    // Nueva función para manejar la apertura del SideCard
    const handleShowSideCard = async (cedisItem) => {
        // console.log("[AdministracionProtocolos] --- Iniciando handleShowSideCard para CEDIS:", cedisItem.nombre_cedis, "---");
        // console.log("[AdministracionProtocolos] cedisItem recibido para SideCard:", cedisItem);

        // Solo mostrar SideCard si hay un protocolo asociado
        if (!cedisItem.protocolos_seguridad || !cedisItem.protocolos_seguridad.protocolo_id) {
            toast.info("Este CEDIS no tiene un protocolo configurado para mostrar detalles.");
            return;
        }

        setIsLoadingProtocolDetails(true); // Usamos el mismo spinner/estado de carga
        setErrorProtocolDetails(null);

        try {
            const protocoloResp = await getProtocolos(cedisItem.cedis_id);
            // console.log("[AdministracionProtocolos] Respuesta de getProtocolos para SideCard:", protocoloResp);

            if (protocoloResp.ok && protocoloResp.protocolo) {
                const gruposResp = await getGruposChat(cedisItem.cedis_id);
                // console.log("[AdministracionProtocolos] Respuesta de getGruposChat para SideCard:", gruposResp);

                const fullProtocolData = {
                    ...protocoloResp.protocolo,
                    cedisNombre: cedisItem.nombre_cedis, // Añadir el nombre del CEDIS
                    escalamientos: protocoloResp.protocolo.protocolo_escalamientos || [],
                    grupos_mensajeria: gruposResp.ok && gruposResp.grupos ? gruposResp.grupos : [],
                };
                setSideCardProtocolData(fullProtocolData);
                setShowSideCard(true);
            } else {
                toast.error(protocoloResp.msg || "Error al cargar los detalles del protocolo para el SideCard.");
                setErrorProtocolDetails(new Error(protocoloResp.msg || "Error desconocido al cargar detalles del protocolo para SideCard."));
            }
        } catch (error) {
            console.error("Error al obtener detalles del protocolo o grupos de chat para SideCard:", error);
            toast.error("Ocurrió un error al cargar los detalles para el SideCard.");
            setErrorProtocolDetails(error);
        } finally {
            setIsLoadingProtocolDetails(false);
        }
    };

    const handleHideModal = () => {
        // console.log("[AdministracionProtocolos] Ocultando modal.");
        setShowModal(false);
        setSelectedProtocol(null);
        setErrorProtocolDetails(null);
        reloadNegocios();
        reloadCedisProtocols(); 
    };

    const handleHideSideCard = () => {
        // console.log("[AdministracionProtocolos] Ocultando SideCard.");
        setShowSideCard(false);
        setSideCardProtocolData(null);
    };

    const handleSaveProtocol = async (updatedProtocolData) => {
        // console.log ("[Administracion de Protocolos] Datos a guardar/Actualizar (solo protocolo principal):", updatedProtocolData);

        let response;
        let newProtocolId = null; // Variable para almacenar el ID del protocolo (nuevo o existente)

        try {
            const isEditing = updatedProtocolData.id && !String(updatedProtocolData.id).startsWith('TEMP_');

            let protocolDataToSend = {
                titulo_protocolo: updatedProtocolData.titulo_protocolo,
                evento_riesgo: updatedProtocolData.evento_riesgo,
            };

            if (isEditing) {
                // console.log("[AdministracionProtocolos] Realizando PUT de protocolo. ID:", updatedProtocolData.id, "Payload:", protocolDataToSend);
                response = await putProtocolos(updatedProtocolData.id, protocolDataToSend);
                newProtocolId = updatedProtocolData.id; // Para PUT, el ID es el mismo
            } else {
                const cedisIdToSend = Number(updatedProtocolData.cedis_id);
                if(isNaN(cedisIdToSend) || cedisIdToSend <= 0){
                    toast.error("Error: El ID del CEDIS es inválido o falta para crear el protocolo.");
                    return { ok: false, msg: "ID de CEDIS inválido." }; // Devolver un objeto de error
                }
                protocolDataToSend = {
                    ...protocolDataToSend,
                    cedis_id: cedisIdToSend,
                };
                // console.log("[AdministracionProtocolos] Realizando POST de protocolo:", protocolDataToSend);
                response = await postProtocolos(protocolDataToSend);
                if (response.ok && response.protocolo) {
                    newProtocolId = response.protocolo.protocolo_id; // Capturar el nuevo ID del protocolo
                    // console.log("[AdministracionProtocolos] Nuevo protocolo ID recibido:", newProtocolId);
                }
            }
            // console.log("[AdministracionProtocolos] Respuesta de guardar protocolo principal:", response);

            if (response.ok) {
                setShouldReloadOnModalClose(true); // Establecer el flag para recargar la lista al cerrar el modal
                // toast.success("Protocolo principal guardado con éxito!");
                return { ok: true, msg: response.msg, protocolId: newProtocolId, cedisId: updatedProtocolData.cedis_id }; // Devolver el ID y cedisId
            } else {
                toast.error(response.msg || "Error al guardar el protocolo principal.");
                return { ok: false, msg: response.msg || "Error al guardar el protocolo principal." };
            }
        } catch (error) {
            console.error("Error al guardar/actualizar protocolo principal:", error);
            toast.error("Ocurrió un error inesperado al guardar el protocolo principal.");
            return { ok: false, msg: "Error inesperado al guardar el protocolo principal." };
        }
    };

    const filteredCedis = selectCedisId
        ? cedisForSelectedNegocio.filter(cedis => cedis.cedis_id === selectCedisId)
            : cedisForSelectedNegocio;

    const offset = currentPage * itemsPerPage;
    const currentCedisForDisplay = filteredCedis.slice(offset, offset + itemsPerPage);

    if(errorNegocios) {
        return <div className="text-center text-danger p-5">Error al cargar los negocios: {errorNegocios.message}. Por favor, revisa la conexión con el servidor o los permisos.</div>
    }

    if (negocios.length === 0 && !isLoadingNegocios) {
        return <div className="text-center text-info p-5">No se encontraron negocios.</div>;
    }

    return (
        <>
            <div className="nombre-componente-contenedor p-15 row justify-content-center">
                <div className="col-3">
                    <Select
                        className="col-4 form-control selectCedis"
                        placeholder="Seleccione el Negocio"
                        options={negocios.map((n) => ({
                            value: n.negocio_id,
                            label: n.negocio_nombre,
                        }))}
                        value={selectedNegocioId && negocios.find(n => n.negocio_id === selectedNegocioId)
                                ? {
                                    value: selectedNegocioId,
                                    label: negocios.find(n => n.negocio_id === selectedNegocioId).negocio_nombre
                                }
                                : null}
                        onChange={(selectedOption) => {
                            setSelectedNegocioId(selectedOption ? selectedOption.value : null);
                            setSelectCedisId(null);
                            setCurrentPage(0);
                        }}
                    />
                </div>
                <div className="col-3">
                    <Select
                        className="col-4 form-control selectCedis"
                        isClearable
                        placeholder={isLoadingCedisProtocols ? "Cargando CEDIS..." : "Seleccione el CEDIS"}
                        options={isLoadingCedisProtocols && cedisForSelectedNegocio.length === 0
                                    ? []
                                    : cedisForSelectedNegocio.map((c) => ({
                                        value: c.cedis_id,
                                        label: c.nombre_cedis,
                                    }))}
                        value={selectCedisId && cedisForSelectedNegocio.find(c => c.cedis_id === selectCedisId)
                                ? {
                                    value: selectCedisId,
                                    label: cedisForSelectedNegocio.find(c => c.cedis_id === selectCedisId).nombre_cedis
                                }
                                : null}
                        onChange={(selectedOption) => {
                            setSelectCedisId(selectedOption ? selectedOption.value : null);
                            setCurrentPage(0);
                        }}
                        isDisabled={isLoadingCedisProtocols}
                        isLoading={isLoadingCedisProtocols}
                    />
                </div>
            </div>
            <div
                className="row g-3"
                style={{ margin: "20px auto", maxWidth: "1400px" }}
            >
                {/* Se elimina la condición isLoadingProtocolDetails de aquí para evitar el spinner al cargar detalles */}
                {isLoadingCedisProtocols ? (
                    <div className="col-12 text-center p-5">
                        <Spinner />
                        <p className="mt-3">Cargando CEDIS y protocolos...</p>
                    </div>
                ) : errorCedisProtocols ? (
                    <div className="col-12 text-center text-danger p-5">Error al cargar CEDIS: {errorCedisProtocols.message}.</div>
                ) : errorProtocolDetails ? (
                    <div className="col-12 text-center text-danger p-5">Error al cargar detalles del protocolo: {errorProtocolDetails.message}.</div>
                ) : currentCedisForDisplay.length > 0 ? (
                    currentCedisForDisplay.map((cedisItem) => {
                        const negocioActual = negocios.find(n => n.negocio_id === selectedNegocioId);
                        const negocioImagenUrl = negocioActual ? `${process.env.REACT_APP_API_URL_LOCAL}negocios/${negocioActual.negocio_id}/bg` : TotalProtect;

                        const hasProtocoloSeguridad = !!cedisItem.protocolos_seguridad;

                        return(
                            <div
                                key={cedisItem.cedis_id}
                                className="col-lg-2 col-md-3 col-sm-4 col-6"
                                style={{display: 'flex', flexDirection: 'column', marginBottom:'1rem'}}
                            >
                                {/* La tarjeta completa es clickeable para el SideCard */}
                                <ProtocoloCard
                                    protocolo={{
                                        id: hasProtocoloSeguridad ? cedisItem.protocolos_seguridad.protocolo_id : "TEMP_" + cedisItem.cedis_id + "_" + selectedNegocioId,
                                        titulo_protocolo: hasProtocoloSeguridad ? cedisItem.protocolos_seguridad.titulo_protocolo : "Protocolo para " + cedisItem.nombre_cedis,
                                        negocio_id: selectedNegocioId,
                                        evento_riesgo: hasProtocoloSeguridad && cedisItem.protocolos_seguridad.evento_riesgo ? cedisItem.protocolos_seguridad.evento_riesgo : '',
                                        cedis_id: cedisItem.cedis_id,
                                        cedisNombre: cedisItem.nombre_cedis,
                                        escalamientos: hasProtocoloSeguridad && cedisItem.protocolos_seguridad.protocolo_escalamientos ? cedisItem.protocolos_seguridad.protocolo_escalamientos :[],
                                        grupos_mensajeria: hasProtocoloSeguridad && cedisItem.protocolos_seguridad.grupos_mensajeria ? cedisItem.protocolos_seguridad.grupos_mensajeria : [],
                                    }}
                                    negocioNombre={negocioActual ? negocioActual.negocio_nombre : 'Negocio Desconocido'}
                                    negocioImagenUrl={negocioImagenUrl}
                                    cedisNombre={cedisItem.nombre_cedis}
                                    onEditClick={(protocoloData) => {
                                        // Cierra el SideCard si está abierto y abre el modal de edición
                                        setShowSideCard(false);
                                        handleShowModal(cedisItem);
                                    }}
                                    onCardClick={(protocoloData) => {
                                        // Abre el SideCard con los detalles del protocolo
                                        handleShowSideCard(cedisItem);
                                    }}
                                    hasProtocols={hasProtocoloSeguridad}
                                />
                            </div>
                        );
                    })
                ) : (
                    <p className="col-12 text-center">No hay CEDIS que coincidan con la selección actual.</p>
                )}
            </div>
            {/* PAGINACIÓN */}
            {pageCount > 1 && (
                <div className="d-flex justify-content-center mt-3">
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={3}
                        marginPagesDisplayed={1}
                        pageCount={pageCount}
                        previousLabel="<"
                        renderOnZeroPageCount={null}
                        containerClassName="pagination"
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        activeClassName="active"
                    />
                </div>
            )}
            {/* Modal de Edicion/Agregar - Solo se muestra si no hay errores y no está cargando */}
            {!isLoadingProtocolDetails && !errorProtocolDetails && (
                <ModalProtocolos
                    show={showModal}
                    onHide={handleHideModal}
                    onSave={handleSaveProtocol}
                    protocoloToEdit={selectedProtocol}
                    hasProtocols={!!selectedProtocol && !String(selectedProtocol.id).startsWith('TEMP_')}
                    onPostEscalamientoFromParent={postEscalamiento}
                    onDeleteEscalamientoFromParent={deleteEscalamiento}
                    onDeleteGruposChatFromParent={deleteGruposChat}
                    onPutGruposChatFromParent={putGruposChat}
                    onPostGruposChatFromParent={postGruposChat}
                    onGetGruposChatFromParent={getGruposChat}
                />
            )}

            {/* Renderizar el SideCard */}
            <SideCard
                show={showSideCard}
                onHide={handleHideSideCard}
                protocoloData={sideCardProtocolData}
            />
        </>
    );
};
